<template>
  <div class="navmenu-container">
    <div class="toggle-container" @click="flagClick()">
      <svg-icon icon-class="列表"></svg-icon>
    </div>
    <el-menu
      :default-active="this.$route.path"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      router
    >
      <template>
        <el-menu-item
          class="onlyFirst"
          key="/user"
          index="/user"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="权限管理"></svg-icon>
          <span class="title-name">权限管理</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/userArea"
          index="/userArea"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="招商经理管理"></svg-icon>
          <span class="title-name">招商经理管理</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/directlyCustomer"
          index="/directlyCustomer"
        >
          <svg-icon icon-class="直客列表" class="svg-icon-big"></svg-icon>
          <span class="title-name">进线列表</span>
        </el-menu-item>
        <!-- <el-menu-item class="onlyFirst" key="/potentialCustomer" index="/potentialCustomer" v-if="role == 'ADMIN' || role == 'AREA_MANAGER' || role == 'ATTRACT_INVESTMENT_ADMIN'">
          <svg-icon icon-class="列表"></svg-icon>
          <span class="title-name">用户画像分析</span>
        </el-menu-item> -->
        <!-- <el-menu-item class="onlyFirst" key="/imei" index="/imei" v-if="role == 'ADMIN'">
          <svg-icon icon-class="列表"></svg-icon>
          <span class="title-name">imei</span>
        </el-menu-item> -->
        <el-menu-item
          class="onlyFirst"
          key="/privateCustomer"
          index="/privateCustomer"
        >
          <svg-icon icon-class="私客列表" class="svg-icon-big"></svg-icon>
          <span class="title-name">有效列表</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/publicCustomer"
          index="/publicCustomer"
        >
          <svg-icon icon-class="公客列表" class="svg-icon-big"></svg-icon>
          <span class="title-name">公客列表</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/invalidCustomer"
          index="/invalidCustomer"
        >
          <svg-icon icon-class="无效列表" class="svg-icon-big"></svg-icon>
          <span class="title-name">无效列表</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/blankCustomer"
          index="/blankCustomer"
        >
          <svg-icon icon-class="黑名单列表" class="svg-icon"></svg-icon>
          <span class="title-name">黑名单列表</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/financeManage"
          index="/financeManage"
        >
          <svg-icon icon-class="财务管理"></svg-icon>
          <span class="title-name">财务管理</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/franchiseManage"
          index="/franchiseManage"
          v-if="role == 'ADMIN' || role == 'ATTRACT_INVESTMENT_ADMIN'"
        >
          <svg-icon icon-class="加盟管理"></svg-icon>
          <span class="title-name">加盟管理</span>
        </el-menu-item>
        <!-- <el-menu-item  class="onlyFirst" key="/promotion" index="/promotion" v-if="role == 'ADMIN' || role == 'ATTRACT_INVESTMENT_ADMIN' ">
            <svg-icon icon-class="AI推荐词"></svg-icon>
            <span class="title-name">AI推荐词</span>
        </el-menu-item>-->
        <el-menu-item
          class="onlyFirst"
          key="/costManage"
          index="/costManage"
          v-if="role == 'ADMIN' || role == 'ATTRACT_INVESTMENT_ADMIN'"
        >
          <svg-icon icon-class="开票管理"></svg-icon>
          <span class="title-name">开票管理</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/promotionManage"
          index="/promotionManage"
          v-if="role == 'AREA_MANAGER'"
        >
          <svg-icon icon-class="费效管理"></svg-icon>
          <span class="title-name">费效管理</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/dataCenter"
          index="/dataCenter"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="数据中心"></svg-icon>
          <span class="title-name">数据中心</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/customerData"
          index="/customerData"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="客户统计"></svg-icon>
          <span class="title-name">客户统计</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/baidu/consumer/check"
          index="/baidu/consumer/check"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="客户统计"></svg-icon>
          <span class="title-name">消费核验</span>
        </el-menu-item>
        <!-- 目前只有超管可见 -->
        <el-menu-item
          class="onlyFirst"
          key="/dataSummary"
          index="/dataSummary"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">销售数据汇总</span>
        </el-menu-item>
        <!-- <el-menu-item class="onlyFirst" key="/live" index="/live" v-if="role == 'ADMIN'">
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">直播</span>
        </el-menu-item> -->
        <el-menu-item
          class="onlyFirst"
          key="/message"
          index="/message"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">通知中心</span>
        </el-menu-item>

        <el-menu-item
          class="onlyFirst"
          key="/dyZhuBoUser"
          index="/dyZhuBoUser"
          v-if="tagList && tagList.indexOf('DY_ZHU_BO') != -1"
        >
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">主播设置</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/merchant/customer/config"
          index="/merchant/customer/config"
          v-if="role == 'ADMIN' || role == 'AREA_MANAGER'"
        >
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">团队管理设置</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/ai/chatMessage"
          index="/ai/chatMessage"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">AI聊天管理</span>
        </el-menu-item>
        <el-menu-item
          class="onlyFirst"
          key="/ol/trace/report"
          index="/ol/trace/report"
          v-if="role == 'ADMIN'"
        >
          <svg-icon icon-class="销售数据汇总"></svg-icon>
          <span class="title-name">在线埋点日报</span>
        </el-menu-item>
      </template>
      <!-- <template v-for="route in permissions">
        <el-menu-item v-if="route.children.length === 0" class="onlyFirst" :key="route.path" :index="route.path">
            <svg-icon :icon-class="route.src"></svg-icon>
            <span class="title-name">{{route.remark}}</span>
        </el-menu-item>
      </template>-->
      <!-- <template v-for="route in permissions">
        <el-submenu v-if="route.children.length !== 0" :key="route.path" :index="route.path" >
          <template slot="title">
            <svg-icon :icon-class="route.src"></svg-icon>
            <span class="title-name">{{route.remark}}</span>
          </template>
          <template v-for="item in route.children">
            <el-menu-item v-if="item.children.length ===0" :key="item.path" style="padding-left:50px;" :index="item.path">{{item.remark}}</el-menu-item>
            <el-submenu v-if="item.children.length !== 0" :key="item.path" style="padding-left:10px;"  :index="item.path">
              <template slot="title">{{item.remark}}</template>
              <el-menu-item v-for="element in item.children" style="padding-left:50px;" :key="element.path" :index="element.path">{{element.remark}}</el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>
      </template>-->
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: "",
      role: "",
      myActivePath: "",
      avaterUrl: "",
      isCollapse: false,
      outPermissions: [],
      permissions: [],
      tagList: []
    };
  },
  created() {
    var userInfo = JSON.parse(sessionStorage.getItem("accountInfo"));
    this.role = userInfo.role;
    this.tagList = userInfo.tagList;
    this.userId = userInfo.id;
    // this.outPermissions = accountInfo.permissions
    // this.getMenu()
  },
  methods: {
    flagClick() {
      this.isCollapse = !this.isCollapse;
      this.$emit("collapse", this.isCollapse);
    },
    findSubNodes(id) {
      let result = this.outPermissions.filter(item => item.parentId === id);
      result.forEach(ele => {
        ele.children = this.findSubNodes(ele.id);
      });
      return result;
    },
    getMenu() {
      this.permissions = this.findSubNodes(null);
      sessionStorage.setItem("permissions", JSON.stringify(this.permissions));
    }
  }
};
</script>

<style scoped>
.navmenu-container {
  background-color: #001528;
  height: 100%;
  /* overflow: auto; */
  overflow-x: hidden;
  overflow-y: scroll;
  width: calc(100% + 20px);
}
.navmenu-container .el-menu-vertical-demo .svg-icon {
  width: 1.3em;
  height: 1.3em;
  vertical-align: -0.4em;
}

.svg-icon-big {
  width: 1.5em !important;
  height: 1.5em !important;
  vertical-align: -0.4em !important;
}
.el-menu-vertical-demo span {
  font-size: 14px;
}
.toggle-container {
  font-size: 14px;
  text-align: right;
  cursor: pointer;
  padding: 10px 25px 0 0;
}
a {
  text-decoration: none;
}
.router-link-active {
  text-decoration: none;
}
.el-menu-vertical-demo {
  height: 100%;
}
.title-name {
  padding: 10px;
}
</style>

<style>
.el-menu {
  background-color: #001528;
}
.el-menu-item,
.el-submenu__title {
  height: 40px;
  line-height: 40px;
  color: #d3d3de;
}
.el-menu-item:hover,
.el-menu-item.onlyFirst:hover,
.el-submenu .el-submenu__title:hover {
  background-color: #0a345a;
}
.el-menu-item.is-active {
  color: #fff;
  background-color: #0090ff;
}
.el-menu-item.is-active.onlyFirst {
  color: #0090ff;
  background-color: #001528;
}
.el-submenu .el-menu-item {
  height: 35px;
  line-height: 35px;
}
.el-submenu.is-active > .el-submenu__title {
  color: #0090ff;
  background-color: #001528;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/navMenu.vue